module.exports = __webpack_public_path__ + "static/media/logo_header_work.97755b11.svg";